<template>
  <div
    class="trade-in-item-container"
    :class="{ '-is-selected': selected }"
    @click="onClick"
  >
    <div class="trade-in-item" :style="itemStyle">
      <div class="trade-in-item-checkmark">
        <span class="checkmark" :style="checkmarkStyle"></span>
      </div>

      <div class="trade-in-item-label">
        {{ label }}
        <span
          v-if="badgeLabel"
          class="trade-in-item-label-badge"
          :style="badgeStyle"
        >
          {{ badgeLabel }}
        </span>

        <div
          v-if="desc"
          class="trade-in-item-desc"
          v-html="desc"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import colorBnn from '@/config/color'

export default {
  name: 'BaseTradeInOptionItem',

  props: {
    label: {
      type: String,
      required: true,
    },
    badgeLabel: {
      type: String,
      default: null,
    },
    badgeColor: {
      type: String,
      default: null,
    },
    desc: {
      type: String,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      colorBnn,
    }
  },

  computed: {
    itemStyle() {
      if (!this.selected) return null

      return {
        backgroundColor: colorBnn['color-bnn-light'],
        border: `1px solid ${colorBnn['color-bnn']}`,
      }
    },

    checkmarkStyle() {
      if (!this.selected) return null

      return {
        border: `5px solid ${colorBnn['color-bnn']}`,
      }
    },

    badgeStyle() {
      if (!this.badgeColor) return null

      return {
        backgroundColor: `${this.badgeColor}33`,
        color: this.badgeColor,
      }
    },
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="stylus" scoped>
.trade-in-item-container {
    .trade-in-item {
        display: flex;
		flex-wrap: wrap;
        align-items: center;
        gap: 12px;
        padding: 12px;

		background-color: #ffffff;
        border: 1px solid #D0D0D0;
        cursor: pointer;
    }
	.trade-in-item-checkmark {
        flex-shrink: 0;
		align-self: baseline;

		width: 24px;
		height: 24px;

		display: flex;
		align-items: center;
		justify-content: center;
	}
    .checkmark {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid #D2D2D7;
        transition: border .1s;
		overflow: hidden;
    }

    .trade-in-item-label {
        flex: 1;
		display: flow-root;
		align-items: baseline;

		> * {
			margin-right: 8px;
		}

		width: fit-content;
		display: inline-block;
		font-weight: 500;
		color: rgba(#000000, 0.70);
    }

    .trade-in-item-label-badge {
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        padding: 2px 6px;
        border-radius: 24px;
        color: #ffffff;
        font-size: 12px;
        font-weight: bold;
        white-space: wrap;
    }

	.trade-in-item-desc {
        flex: none;
		flex-basis: 100%;
		font-size: 14px;
		margin-top: 16px;
	}
}
</style>
